import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 order-2 lg:order-1 flex justify-center">
            <div className="relative w-[220px] h-[400px] md:w-[260px] md:h-[480px] bg-background-200 rounded-3xl overflow-hidden border-4 border-background-300">
              <div className="absolute top-0 left-0 w-full h-8 bg-background-300 flex items-center justify-center">
                <div className="w-16 h-1.5 rounded-full bg-background-400"></div>
              </div>
              <div className="pt-10 px-4">
                <div className="text-center mb-4">
                  <span className="text-3xl">🍉</span>
                  <p className="font-heading text-lg text-foreground-900 mt-2">吃瓜网站</p>
                  <p className="text-xs text-foreground-500">移动端专属入口</p>
                </div>
                <div className="space-y-2">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="h-10 rounded-lg bg-primary-100/60"></div>
                  ))}
                  <div className="h-10 rounded-lg bg-accent-100/60"></div>
                  <div className="h-10 rounded-lg bg-secondary-100/60"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 order-1 lg:order-2 text-center lg:text-left">
            <p className="text-xs font-semibold text-accent-500 uppercase tracking-wider mb-2">MOBILE ACCESS</p>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-4">{appData.title}</h2>
            <p className="text-lg text-primary-500 font-semibold mb-4">{appData.subtitle}</p>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0 mb-6">{appData.description}</p>
            <div className="flex flex-wrap gap-3 justify-center lg:justify-start">
              {appData.features.map((f) => (
                <span key={f} className="px-4 py-1.5 rounded-full text-xs font-medium bg-background-200 text-foreground-700 whitespace-nowrap">
                  {f}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}